/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { faChevronUp } from '@fortawesome/free-solid-svg-icons/faChevronUp'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { PropsWithChildren, useCallback, useState } from 'react'
import { Box, BoxProps, Button, Collapse, Stack } from '@mantine/core'

export type FormSectionProps = PropsWithChildren & BoxProps & {
  defaultOpened?: boolean,
  id?: string,
  title?: string,
}

function FormSection (props: FormSectionProps) {
  const {
    children,
    defaultOpened,
    title,
    ...others
  } = props

  const [open, setOpen] = useState(defaultOpened)
  const toggleOpen = useCallback(() => setOpen((s) => !s), [])
  return (
    <Box
      component="fieldset"
      px={0}
      py="sm"
      style={{ border: 'none' }}
      {...others}
    >
      <Button
        component="legend"
        fullWidth
        onClick={toggleOpen}
        tt="uppercase"
        variant="light"
        justify="left"
        leftSection={<FontAwesomeIcon
          fixedWidth
          icon={faChevronUp}
          rotation={open ? undefined : 180}
          size="xs"
        />}
      >
        {title}
      </Button>
      <Collapse in={open}>
        <Stack>
          {children}
        </Stack>
      </Collapse>
    </Box>
  )
}

export default FormSection
